import { render, staticRenderFns } from "./registe.vue?vue&type=template&id=198a92fb&scoped=true"
import script from "./registe.vue?vue&type=script&lang=js"
export * from "./registe.vue?vue&type=script&lang=js"
import style0 from "./registe.vue?vue&type=style&index=0&id=198a92fb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "198a92fb",
  null
  
)

export default component.exports